











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EndRetrospectiveMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetrospectiveMeeting",
      "kind": "LinkedField",
      "name": "meeting",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WholeMeetingSummary_meeting"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EndRetrospectiveSuccess",
  "abstractKey": null
};

(node ).hash = "df7643644ccac10e94116f32afd5ed9c";

export default node;
